import {gql, useQuery} from "@apollo/client";
import {useLogger} from "./useLogger";
import {useContext} from "react";
import {LocaleContext} from "../store/providers/LocaleProvider";

const QUERY = gql`
query getTagChips($locale: String!) {
	tagsCollection(
        locale: $locale
        where: {
			filterTagOnOverviewPage: true
		}
        ){
		total
		items{
			tag
			filterTagOnOverviewPage
			slug
		}
	}
}
`;

export const useFilterTags = () => {
    const {logger} = useLogger();
    const {localeUppercase} = useContext(LocaleContext)[0];
    const {data, loading, error} = useQuery(QUERY, { variables: { locale: localeUppercase}, errorPolicy: "all"});

    const filterTags = data?.tagsCollection?.items;

    if (error?.message) {
        logger(error?.message, "error", "useFilterTags", error?.stack);
    }

    return {
        filterTags,
        loading,
        error
    };
};
